module.exports = __webpack_public_path__ + "media/images/result_sets/circles/7r6n5r1r-31ba0cd09a64b56d351258613e1763ee.svg";